
import Axios from 'axios';
import store from '../store/index';
export default () => {
        return Axios.create({
            baseURL:process.env.VUE_APP_BACKEND_URL,
            headers: {
                Authorization: `Bearer ${store.getters.feLoggedId}`
            }
        })       

    }